import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8aa5kchc2z: FaireBrandEntity = {
  token: "b_8aa5kchc2z",
  type: "brand",
  name: "Homecourt",
  avatarUrl:
    "https://cdn.faire.com/fastly/bf90884ec7df4822dfdef3fd5636dd39b6e50ca9265aad5f4639cf661ca5ea44.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/88ab91a568f16f4be8a4a4a5033944728944463b5f0e23951514591583716ff8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bf90884ec7df4822dfdef3fd5636dd39b6e50ca9265aad5f4639cf661ca5ea44.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/88ab91a568f16f4be8a4a4a5033944728944463b5f0e23951514591583716ff8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 750,
  rating: 4.9,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "I created Homecourt because my home is my sanctuary. It is a home that’s filled with love and laughter, and a place where I can spend quality time with friends and family. I have taken great care to curate a space where everyone can feel “at home.” Our homes are the one place that can bring a sense of calm and serenity in our lives. Collectively, we seek good health, good habits, and wellness routines that make us feel like we are putting our best foot forward—so why not extend that philosophy into homecare?\n\nSomeone once told me that caring for your space can be a transformative act. As a self-proclaimed neat freak, I can tell you that this is true, but I could never find products that smelled or looked as good as they worked, nor anything that truly elevated homecare to what I’ve always felt it should be: an investment in yourself and your loved ones, and a daily act of self-care.\n\nSo, I sought out the best perfumers to create custom fragrances; worked alongside skincare chemists to develop non-toxic, yet incredibly effective formulas, and collaborated with trailblazers in sustainable design to launch this collection of, well, beauty products for the home.\n\nI’m so excited to share our hard work and passion with you. It’s time to discover the beauty of homecare.\n\nCourteney Cox, Founder\n\n*For any questions regarding our line, please reach out to [redacted-email] for additional information* \n\n",
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:29:55.229Z",
    importedBy: "entity-db-cli",
  },
};
